import { Icon } from "@plura/client/components";
import { cn } from "@plura/shared/utils";
import { faClassToPluraIcon } from "../../../lib/faToPluraIconName";

type LandingIconProps = { faClass: string; className?: string };

/** Renders a shared `Icon` from legacy Font Awesome (`fa-*`) or Remix (`ri-*`) class strings. */
export function LandingIcon({ faClass, className }: LandingIconProps) {
    const { name, iconClass } = faClassToPluraIcon(faClass);
    return <Icon name={name} className={cn(iconClass, className)} />;
}
